import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectPagesRoute: InvariantJiraRoute = {
	name: 'project-pages',
	path: '/jira/:projectType(software|software/c|servicedesk)/projects/:projectKey/pages',
};
